// Utility function to Santize TinyMCE fields
const pkg = require('@/../package.json')

const env = process.env.VUE_APP_ENV || 'development'

const { productionBaseUrl, stagingBaseUrl } = pkg.config
const baseUrl = env === 'production' ? productionBaseUrl : stagingBaseUrl

export default {
  methods: {
    wysiwygFilter(inputHTML) {
      // Drop HTML in an element to parse it
      const $el = document.createElement('div')
      $el.innerHTML = inputHTML
      // Query Anchors to force new tabs
      $el.querySelectorAll('a').forEach($anchor => {
        // Make sure anchors that are external have targer_blank
        const containsBaseUrl = $anchor.href.indexOf(baseUrl) !== -1
        const hashHref = $anchor.href[0] === '#'
        const localhostHref = $anchor.href.indexOf('localhost') !== -1
        if (!containsBaseUrl && !hashHref && !localhostHref) {
          $anchor.setAttribute('target', '_blank')
          $anchor.removeAttribute('rel')
          $anchor.setAttribute('href', $anchor.href)
        }
      })
      // Return just the HTML
      return $el.innerHTML
    }
  }
}
